import React, { Suspense } from "react";
import { createBrowserRouter } from "react-router-dom";
import Loader from "../components/Loader";

const SignIn = React.lazy(() => import("../pages/SignIn"));
const Code = React.lazy(() => import("../pages/Code"));
const Reset = React.lazy(() => import("../pages/Reset"));
const Vertical = React.lazy(() => import("../pages/Vertical"));

export const router = createBrowserRouter([
  {
    path: "/login",
    element: (
      <Suspense fallback={<Loader />}>
        <SignIn />
      </Suspense>
    ),
  },
  {
    path: "/reset",
    element: (
      <Suspense fallback={<Loader />}>
        <Reset />
      </Suspense>
    ),
  },
  {
    path: "/code/:code",
    element: (
      <Suspense fallback={<Loader />}>
        <Code />
      </Suspense>
    ),
  },
  {
    path: "/v/:rotation",
    element: (
      <Suspense fallback={<Loader />}>
        <Vertical />
      </Suspense>
    ),
  },
  {
    path: "*",
    element: (
      <Suspense fallback={<Loader />}>
        <SignIn />
      </Suspense>
    ),
  },
]);
